import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  TrackByFunction,
  inject
} from '@angular/core';
import { Params, Router, RouterModule } from '@angular/router';
import { Observable, filter, map } from 'rxjs';
import { ScreenSizeService, ViewMode } from '../../services/screen-size';

type Breadcrumb = {
  link?: string;
  title: string;
};

@Component({
  selector: 'now-wbsuche-lib-breadcrumb',
  imports: [CommonModule, RouterModule],
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly ref = inject<ElementRef<HTMLElement>>(ElementRef);
  private readonly screenSizeService = inject(ScreenSizeService);

  public breabcrumbList: Breadcrumb[] = [{ link: '/', title: 'Weiterbildungssuche' }];
  public expanded = false;
  public queryParams$: Observable<Params> = this.screenSizeService.rangeTo$(ViewMode.DESKTOP).pipe(
    filter(Boolean),
    map(() => ({ angebot: null }))
  );

  ngOnInit(): void {
    if (this.router.url.includes('/termin/')) {
      this.breabcrumbList.push({ title: 'Termin' });
    }
    if (this.router.url.includes('/themenfelder')) {
      this.breabcrumbList.push({ title: 'Themenfelder' });
    }
  }

  @HostListener('window:mousedown', ['$event'])
  mouseClickHandler(event: Event): void {
    this.expanded = this.ref.nativeElement.contains(event.target as Element);
  }

  public trackByIndex: TrackByFunction<Breadcrumb> = (index) => index;
}
